// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"a5a9e68441cc0d902eec","453":"53bd020961646278c1a8"}[chunkId] + ".js";
};